import React, { FC, memo } from 'react'
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'
import ReactPlayer from 'react-player'

import styles from './styles.module.scss'

interface IProps {
  url: string
  playing: boolean
  setPlayingVideo: (value: string) => void
}

export const Video: FC<IProps> = memo(({ url, setPlayingVideo, playing }) => {
  const handleClick = () => {
    if (playing) {
      setPlayingVideo('')
    } else {
      setPlayingVideo(url)
    }
  }

  return (
    <div onClick={handleClick} className={cn({
      [styles.videoPlayerWrapper]: true
    })}>
      <ReactPlayer
        url={url}
        className={styles.reactPlayer}
        volume={1}
        playing={playing}
        // loop
        // muted
        playsinline
        width="100%"
        height="100%"
        config={{
          youtube: {
            playerVars: {
              controls: 1,
              origin: process.env.REACT_APP_YOUTUBE_ORIGIN_URL
            }
          }
        }}
      />
      <div className={cn({
        [styles.playMask]: true,
        [styles.playMaskPlaying]: playing
      })}>
        <div className={cn({
          [styles.videoPlay]: true,
          [styles.videoPlaying]: playing
        })}>
          <div className={styles.videoPlayInner}>
            <button className={styles.playBtn}>Play The Trailer</button>
          </div>
        </div>
      </div>
    </div>
  )
})
